// Set your API base here
// For local demo: export const API_BASE = "http://44.240.221.20:5001";
export const API_BASE = "https://api.mutcloud.com";

export async function fetchShiftSummary({ tenantId, siteId, shiftName, dateStart, dateEnd, options }) {
  const res = await fetch(`${API_BASE}/ai-tools/getShiftSummary`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      tenantId: tenantId || siteId, // allow either
      siteId,
      shiftName,
      dateStart,
      dateEnd,
      options: options || { includeMachines: true }
    }),
  });
  if (!res.ok) throw new Error("API error " + res.status);
  return res.json();
}

export async function fetchShiftSummaryRange(params) {
  return fetchShiftSummary(params);
}

export async function fetchCurrentShiftSummary({ tenantId, siteId, options, downtimePath }) {
  const res = await fetch(`${API_BASE}/ai-tools/currentShift`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      tenantId: tenantId || siteId,
      siteId,
      downtimePath,
      options: options || { includeMachines: true }
    })
  });
  if (!res.ok) throw new Error("API error " + res.status);
  return res.json();
}
